import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Helmet } from 'react-helmet-async';
import { Input, Button } from 'rsuite';
import { useAuth } from '../../AuthContext';
import FolderIcon from '@rsuite/icons/Folder';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Loader } from 'rsuite';

function EditDelticomContact() {
  const { auth } = useAuth();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate(); // Initialize useNavigate

  const [delticom, setDelticom] = useState([]);
  const [contact, setContact] = useState(null);

  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("id"); // Extract 'id' from URL

  const [address, setAddress] = useState('');
  const [country, setCountry] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [customerName, setCustomerName] = useState('');
  const [postAddress, setPostAddress] = useState('');
  const [postNumber, setPostNumber] = useState('');
  const [telephone, setTelephone] = useState('');

  useEffect(() => {
    if (orderId) {
      fetchData();   // Fetch data when orderId changes
    }
  }, [orderId]);
  
  useEffect(() => {
    if (delticom && orderId) {
      setValues();   // Call the function when delticom updates
    }
  }, [delticom, orderId]);
  
  function setValues() {
    if (contact) {  // Assuming 'contact' is already defined
      setAddress(contact.address);
      setCountry(contact.country);
      setCountryCode(contact.countryCode);
      setCompanyName(contact.customerCmpName);
      setCustomerName(contact.customerName);
      setPostAddress(contact.postAddress);
      setPostNumber(contact.postNr);
      setTelephone(contact.telephone);  // Corrected here
    }
  }
  


  const fetchData = async () => {
      setLoading(true);
  
      try {
          const response = await fetch(`${process.env.REACT_APP_BASE_URL}/delticom/order-info?id=${orderId}`, { // Removed extra '}'
              method: "GET",
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${auth.token}`
              }
          });
  
          if (!response.ok) {
              const errorText = await response.text();
              throw new Error(`Misslyckades att hämta orderdata: ${errorText}`);
          }
  
          const data = await response.json();
  
          // ✅ Update state variables
          setContact(data.customer);
          setDelticom(data.delticom)
  
      } catch (error) {
          console.error("Error fetching order info:", error.message);
          toast.error(error.message, {
              position: 'bottom-right'
          });
      } finally {
          setLoading(false);
      }
    };

    const handleSubmit = async () => {
        if (!address || !country || !countryCode || !customerName || !postAddress || !postNumber) {
          toast.error('Samtliga fält måste fyllas i.', {
            position: 'bottom-right'
          });
          return;
        }
    
        setLoading(true);
        const formData = {
          id: delticom?.id,
          address,
          country,
          countryCode,
          companyName,
          customerName,
          postAddress,
          postNumber,
          telephone
        };
    
        try {
          const response = await fetch(`${process.env.REACT_APP_BASE_URL}/delticom/edit-customer`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth.token}`
            },
            body: JSON.stringify(formData),
          });
    
          const result = await response.json();
    
          if (response.ok) {
            toast.success(result.message, {
              position: 'bottom-right'
            });
            navigate(`/admin/order?id=${delticom.id}`);
          } else {
            toast.error(result.message, {
              position: 'bottom-right'
            });
          }
        } catch (error) {
          console.log(error);
          toast.error('Misslyckades att redigera uppgifter: ', error, {
            position: 'bottom-right'
          });
        } finally {
          setLoading(false);
        }
      };

  return (
    <>
        <Helmet>
          <title>{`Redigera - ${delticom?.orderNr}`}</title>
        </Helmet>
        <div className='px-5 pt-4 w-100'>
        <h4 className="mb-2">Redigera uppgifter - {delticom?.orderNr}</h4>
        <p className="text-muted">Order skapad {delticom?.dateCreated}</p>
        <hr />
        <div className="row">

          <div className="col-sm-12 col-md-12 col-lg-6 mb-2">
            <label htmlFor="address" className="fs-5">Adress</label>
            <Input
              id="address"
              placeholder="Adress"
              value={address}
              onChange={(value) => setAddress(value)}
            />
          </div>

          <div className="col-sm-12 col-md-12 col-lg-6 mb-2">
            <label htmlFor="country" className="fs-5">Land</label>
            <Input
              id="country"
              placeholder="Land"
              value={country}
              onChange={(value) => setCountry(value)}
            />
          </div>

          <div className="col-sm-12 col-md-12 col-lg-6 mb-2">
            <label htmlFor="countryCode" className="fs-5">Landskod</label>
            <Input
              id="countryCode"
              placeholder="Landskod"
              value={countryCode}
              onChange={(value) => setCountryCode(value)}
            />
          </div>

          <div className="col-sm-12 col-md-12 col-lg-6 mb-2">
            <label htmlFor="companyName" className="fs-5">Företagsnamn</label>
            <Input
              id="companyName"
              placeholder="Företagsnamn"
              value={companyName}
              onChange={(value) => setCompanyName(value)}
            />
          </div>

          <div className="col-sm-12 col-md-12 col-lg-6 mb-2">
            <label htmlFor="customerName" className="fs-5">Kundnamn</label>
            <Input
              id="customerName"
              placeholder="Kundnamn"
              value={customerName}
              onChange={(value) => setCustomerName(value)}
            />
          </div>

          <div className="col-sm-12 col-md-12 col-lg-6 mb-2">
            <label htmlFor="postAddress" className="fs-5">Post adress</label>
            <Input
              id="postAddress"
              placeholder="Post adress"
              value={postAddress}
              onChange={(value) => setPostAddress(value)}
            />
          </div>

          <div className="col-sm-12 col-md-12 col-lg-6 mb-2">
            <label htmlFor="postNumber" className="fs-5">Post nummer</label>
            <Input
              id="postNumber"
              placeholder="Post nummer"
              value={postNumber}
              onChange={(value) => setPostNumber(value)}
            />
          </div>

          <div className="col-sm-12 col-md-12 col-lg-6 mb-2">
            <label htmlFor="telephone" className="fs-5">Telefon</label>
            <Input
              id="telephone"
              placeholder="Telefon"
              value={telephone}
              onChange={(value) => setTelephone(value)}
            />
          </div>
        </div>
        <Button appearance="primary" onClick={handleSubmit}>Spara ändringar</Button>
        <hr />
        <h4 className="mb-2">Beställaruppgifter</h4>
        <p>
        {delticom?.rawData?.split('\n').map((line, index) => (
            <React.Fragment key={index}>
            {line}
            <br />
            </React.Fragment>
        ))}
        </p>


        </div>
    </>
  );
}

export default EditDelticomContact;
